//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LogTableData',
  props: {
    orderLogList: {
      type: Array,
      default: []
    }
  }
};